/*
 * HSOC tracking foundation.
 *
 * This shared library can't own a tracker: its runtime hosts (public + in-app)
 * emit through the legacy usage-tracker, which is a restricted dependency for
 * new packages, and they don't bootstrap quartz-tracking. So the consuming app
 * injects a single low-level `track` callback (carried on PlanQuizDataContext)
 * and the quiz maps its own events onto it via usePlanQuizTracking. When this
 * package becomes a standalone Quartz app it swaps the injected callback for a
 * local quartz-tracking `track` of the same shape — nothing else changes.
 */

export const TRACKING_SOURCES = {
  PLAN_QUIZ_MODAL: 'plan-quiz-modal',
  HELP_ME_CHOOSE: 'help-me-choose'
};
export const HSOC_V2_SCREEN = 'flex-seats-and-credits';

/* The value types a tracked event payload can carry. Kept local so the library
 * takes no tracker dependency; assignable to the host tracker's wider
 * EventProperties. */

/* The injected `track` callback: namespace ('Pricing Pages') is the consumer's
 * concern, so it only takes the event name and payload. */